import React from 'react'

import HorizontalMenuItem from "../../../../../layout/top/header/h-menu/h-menu-item-2"
import {COVER_SELECTOR_MENU_HEIGHT} from "../selector-popover"
import ControlButtonStandard from "../../../buttons/control-button/control-button-standard"
import {CoverType} from "../../cover-type";

type Props = {
    currentCoverType: CoverType

    showRemove      : boolean

    onSelect        : callback
    onRemove        : callback
    enableAttachments: boolean

}

const debug = false
// const debug = "CoverSelectorMenu"

export default function CoverSelectorMenu (props:Props) {

    const menuItems = props.enableAttachments ?
        [
            {id: CoverType.GALLERY, label: 'Gallery'},
            {id: CoverType.LINK, label: 'Link'},
            {id: CoverType.ATTACHMENT, label: 'Attachment'},
        ] :
        [
            {id: CoverType.GALLERY, label: 'Gallery'},
            {id: CoverType.LINK, label: 'Link'},
        ]


    return (
        <div className="cover-selector-menu flex-row-left-bottom flex-no-shrink" style={{height: COVER_SELECTOR_MENU_HEIGHT}}>
            <div className="ui5-hmenu menu-underline selector-menu">
                {_.map(menuItems, (menu:any)=><HorizontalMenuItem key           = {menu.id}
                                                                  data          = {menu}
                                                                  selectedId    = {props.currentCoverType}
                                                                  onClick       = {props.onSelect}/>)}
            </div>

            {props.showRemove &&
                <ControlButtonStandard className="remove-button" onClick={()=>{props.onRemove()}}>
                    <div className="ui5-ico-13 i5-trash-alt red m-l-10 m-r-8"/>
                    <div className="ui5-txt-not-important-small m-r-10">Remove</div>
                </ControlButtonStandard>}
        </div>
    )
}
